export default "__VITE_ASSET__D1sJyNB7__"